'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dConfig$002dPage$0024 from "./presto.-Config-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002495 from "./presto.-Presto-Router$$anon$95.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$94() {
  this.boL = null;
  this.boD = null;
  this.boE = false;
  this.boM = null;
  this.boN = false;
  this.boQ = null;
  this.boJ = null;
  this.boK = false;
  this.boF = null;
  this.boG = false;
  this.boH = null;
  this.boI = false;
  this.boO = false;
  this.boP = false;
  this.boL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.boQ = "ConfigPage";
}
export { $c_Lpresto_PrestoRouter$$anon$94 as $c_Lpresto_PrestoRouter$$anon$94 };
$p = $c_Lpresto_PrestoRouter$$anon$94.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$94;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$94() {
}
export { $h_Lpresto_PrestoRouter$$anon$94 as $h_Lpresto_PrestoRouter$$anon$94 };
$h_Lpresto_PrestoRouter$$anon$94.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.boL;
});
$p.M = (function() {
  if ((!this.boE)) {
    this.boD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.boE = true;
  }
  return this.boD;
});
$p.O = (function() {
  if ((!this.boN)) {
    this.boM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boN = true;
  }
  return this.boM;
});
$p.E = (function() {
  return this.boQ;
});
$p.t = (function() {
  if ((!this.boK)) {
    this.boJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boK = true;
  }
  return this.boJ;
});
$p.N = (function() {
  if ((!this.boG)) {
    this.boF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boG = true;
  }
  return this.boF;
});
$p.Q = (function() {
  if ((!this.boI)) {
    this.boH = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002495.$c_Lpresto_PrestoRouter$$anon$95();
    this.boI = true;
  }
  return this.boH;
});
$p.v = (function() {
  if ((!this.boP)) {
    this.boO = false;
    this.boP = true;
  }
  return this.boO;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee590) => ((p) => \u03b4scrutinee590))($j_presto$002e$002dConfig$002dPage$0024.$m_Lpresto_ConfigPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$94 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$94, "presto.PrestoRouter$$anon$94", ({
  Pd: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$94 as $d_Lpresto_PrestoRouter$$anon$94 };
//# sourceMappingURL=presto.-Presto-Router$$anon$94.js.map
